import React from 'react';

import Link from '@skippay/core/components/Link';
import Step from '@skippay/core/components/Step';
import CheckboxField from '@skippay/core/form-fields/CheckboxField';
import { FormattedMessage } from '@skippay/core/i18n/intl';

import { PRIVACY_POLICY_GENERATED_HTML, ROUTES } from 'constants/routes';

const renderRegistrationConsentsCheckboxField = (props) => {
	return (
		<CheckboxField
			alignTop
			label={
				<>
					<Step v xxxs />
					<FormattedMessage
						defaultMessage="Seznámil jsem se s {linkTermsAndConditions} a {linkPersonalDataProcessingRules} a beru na vědomí automatizované zpracování mých dat."
						id="RegistrationConsentCheckboxField.fieldLabelSlugRegistration"
						values={{
							linkPersonalDataProcessingRules: (
								<Link
									openInPopupBrowser
									shareUserSession
									target="_blank"
									testId="informationMemorandum"
									to={
										process.env.MOB_APP_BUILD
											? PRIVACY_POLICY_GENERATED_HTML
											: ROUTES(props.locale).informationMemorandum
									}
									isExternal
								>
									{process.env.MOB_APP_BUILD ? (
										<FormattedMessage
											defaultMessage="pravidly pro zpracování osobních údajů (Privacy Policy)"
											id="RegistrationConsentCheckboxField.linkPersonalDataProcessingRules.mobApp"
										/>
									) : (
										<FormattedMessage
											defaultMessage="pravidly pro zpracování osobních údajů"
											id="RegistrationConsentCheckboxField.linkPersonalDataProcessingRules"
										/>
									)}
								</Link>
							),
							linkTermsAndConditions: (
								<Link
									openInPopupBrowser
									shareUserSession
									target="_blank"
									testId="termsAndConditions"
									to={ROUTES(props.locale).conditions}
								>
									<FormattedMessage
										defaultMessage="obchodními podmínkami"
										id="RegistrationConsentCheckboxField.linkTermsAndConditions"
									/>
								</Link>
							),
						}}
					/>
				</>
			}
			{...props}
		/>
	);
};

const RegistrationConsentsCheckboxField = renderRegistrationConsentsCheckboxField;

export default RegistrationConsentsCheckboxField;
